import React, {Fragment, useState, useEffect} from 'react'
import axios from 'axios';
import globals from 'react-global-configuration';
import {EventoMultiple} from '../components/EventoMultiple'
import {EventoUnico} from '../components/EventoUnico'
import Context from '../Context'

export const Home = (props) => {
    const _URL_REST = globals.get('_URL_REST')
    const [listSettings, setSettings] = useState(false);
    const fetchSettings = async () => {
        console.log('url',`${_URL_REST}/getsettings/${process.env.REACT_APP_EVENTO_ID}`)
        const result = await axios(
            `${_URL_REST}/getsettings/${process.env.REACT_APP_EVENTO_ID}`,
        );
        setSettings(result.data[0])
    };
    
    useEffect(() => {
        fetchSettings();
    },[]);
    
    if(!listSettings) { return(<div></div>) }
    if(listSettings.multiEvento){
        return(
            <Context.Consumer>
            {
                ({song,changeSong}) => {
                    return(     
                    <Fragment>
                        <EventoMultiple song={song} changeSong={changeSong}   idjornada={props.idjornada} settingsEvento={props.eventoesmultiples}/>
                    </Fragment>)
                    
                }
            }
            </Context.Consumer>
            )
    }else{
        return(
            <Context.Consumer>
            {
                ({song,changeSong}) => {
                    return( 
                    <Fragment>
                        <EventoUnico id={listSettings.idEvento} song={song} changeSong={changeSong}    idjornada={props.idjornada} settingsEvento={props.eventoesmultiples}/>
                    </Fragment>)
                }
            }
            </Context.Consumer>
        )
    }


    
}


